import React from 'react';
import { Flex, FlexProps } from '@mezzoforte/forge';
import { BoxProps } from '@chakra-ui/react';
import { FocusableBox } from '@/components/Box/FocusableBox';

function Wrapper(props: BoxProps) {
  return (
    <Flex
      as="article"
      borderRadius={{ md: 8 }}
      borderBottom={{ base: '1px solid', md: 'none' }}
      borderColor={{ base: 'lineBorder' }}
      boxShadow={{ md: 'box' }}
      width={{ base: '100%', md: 'auto' }}
      minH={{ base: 'auto', md: 356, lg: 400 }}
      overflow="hidden"
      position="relative"
      sx={{
        contentVisibility: 'auto',
        containIntrinsicSize: '300px 400px',
      }}
      {...props}
    />
  );
}

export const EntryListItem = FocusableBox<FlexProps>(Wrapper);
